const Cake = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path d="M1.8214 19.5127H18.8452" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.76569 19.5121V11.8514C2.76569 10.4384 4.03397 9.29785 5.60016 9.29785H15.0569C16.6231 9.29785 17.8913 10.4384 17.8913 11.8514V19.5121"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.85211 9.29794V6.88908C4.85211 5.86765 5.7714 5.04199 6.91199 5.04199H13.7641C14.8962 5.04199 15.8154 5.86765 15.8154 6.88908V9.29794"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.12313 12.6855L3.43807 12.6941C4.06795 12.7026 4.57015 13.2133 4.57015 13.8432V14.1241C4.57015 14.7539 5.08087 15.2732 5.71926 15.2732C6.34914 15.2732 6.86837 14.7625 6.86837 14.1241V13.8602C6.86837 13.2303 7.37908 12.7111 8.01748 12.7111C8.64736 12.7111 9.16658 13.2218 9.16658 13.8602V14.1241C9.16658 14.7539 9.6773 15.2732 10.3157 15.2732C10.9456 15.2732 11.4648 14.7625 11.4648 14.1241V13.8602C11.4648 13.2303 11.9755 12.7111 12.6139 12.7111C13.2438 12.7111 13.763 13.2218 13.763 13.8602V14.1241C13.763 14.7539 14.2737 15.2732 14.9121 15.2732C15.542 15.2732 16.0612 14.7625 16.0612 14.1241V13.8602C16.0612 13.2303 16.5719 12.7111 17.2103 12.7111H17.5934"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.92855 5.04222V3.33984"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7381 5.04222V3.33984"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3333 5.04185V2.48828"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Cake;
